import { useEffect } from 'react';
export default function useCloseOnOutsideClick(ref,onClose){

  useEffect(() => {
    if( onClose ){
      const click = e => {

        let path = e.composedPath();
        console.log("ref");
        console.log(ref.current);
        console.log("The path---");
        console.log(path);
        console.log("---- ref ----");



        if( !ref.current ){
          //;
        }
        

        if( ref.current && !path.includes(ref.current) ){
          console.log("Path was:");
          console.log(path);
          console.log("We should close (unless we've clicked on the open item)!");
          onClose(e);
        }
      }

      //this is MOUSEDOWNCAPTURE
      window.addEventListener('mousedown',click);

      return () => {
        window.removeEventListener('mousedown',click);
      }
    }

  },[])

}
